import React from 'react'

import IconButton from './IconButton'

// Trefferliste am Ortskern, wie sie auch der Import abruft, und die Speisekarte eines Restaurants.
export const getLieferandoSettlementUrl = ({
	zipCode,
	lat,
	lon,
}: {
	zipCode: string
	lat: number
	lon: number
}): string => `https://www.lieferando.de/lieferservice/essen/${zipCode}?lat=${lat}&lng=${lon}`

export const getLieferandoRestaurantUrl = (slug: string): string =>
	`https://www.lieferando.de/speisekarte/${slug}`

// Öffnet eine Lieferando-Seite in einem neuen Tab.
const LieferandoLinkButton = ({ url, toolTip }: { url: string; toolTip: string }): JSX.Element => {
	const handleClick = React.useCallback(() => window.open(url, '_blank', 'noopener'), [url])

	return <IconButton iconName="OpenInNew" toolTip={toolTip} onClick={handleClick} />
}

export default React.memo(LieferandoLinkButton)
